module.exports = __webpack_public_path__ + "static/media/pair-logo-animation.6385c675.gif";